// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M1 3V21H23V3H1ZM18 7H6L4.5 5H19.5L18 7ZM10 13.5C10 14.8807 8.88071 16 7.5 16C6.11929 16 5 14.8807 5 13.5C5 12.1193 6.11929 11 7.5 11C8.88071 11 10 12.1193 10 13.5ZM19 13.5C19 14.8807 17.8807 16 16.5 16C15.1193 16 14 14.8807 14 13.5C14 12.1193 15.1193 11 16.5 11C17.8807 11 19 12.1193 19 13.5Z"}}]};

const TapeFilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'tape-filled',
    ref,
    icon: element,
  },
));

TapeFilledIcon.displayName = 'TapeFilledIcon';

export default TapeFilledIcon;
